"use strict";

exports.__esModule = true;
exports["default"] = exports.TooltipSortSelect = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _Selector = require("../../Core/Selector");
var _tooltipSort = require("./tooltipSort");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var TooltipSortSelect = exports.TooltipSortSelect = function TooltipSortSelect(_ref) {
  var _ref$tooltipSort = _ref.tooltipSort,
    tooltipSort = _ref$tooltipSort === void 0 ? _tooltipSort.TOOLTIP_SORT_DESC : _ref$tooltipSort,
    onTooltipSortChange = _ref.onTooltipSortChange,
    style = _ref.style,
    _ref$dataTestId = _ref.dataTestId,
    dataTestId = _ref$dataTestId === void 0 ? "TooltipSort" : _ref$dataTestId;
  var selected = _tooltipSort.TOOLTIP_SORT_OPTIONS.find(function (option) {
    return option.key === tooltipSort;
  }) || _tooltipSort.TOOLTIP_SORT_OPTIONS[0];
  return /*#__PURE__*/_react["default"].createElement(SortControl, {
    "data-testid": dataTestId
  }, /*#__PURE__*/_react["default"].createElement(_Selector.Selector, {
    dataTestId: dataTestId + ".Selector",
    items: _tooltipSort.TOOLTIP_SORT_OPTIONS,
    selected: [selected],
    getKey: function getKey(item) {
      return item.key;
    },
    renderItemText: function renderItemText(item) {
      return item.label;
    },
    onSelect: function onSelect(_ref2) {
      var item = _ref2[0];
      if (item && onTooltipSortChange) {
        onTooltipSortChange(item.key);
      }
    },
    multiple: false,
    toggle: false,
    filterable: false,
    small: true,
    minimal: true,
    rightIcon: _icons.IconNames.DOUBLE_CARET_VERTICAL,
    style: style,
    placeholder: selected.label
  }, /*#__PURE__*/_react["default"].createElement(SortButton, {
    "data-testid": "Selector.selectorButton",
    small: true,
    minimal: true,
    rightIcon: _icons.IconNames.DOUBLE_CARET_VERTICAL,
    text: selected.label,
    style: style
  })));
};
var SortControl = _styledComponents["default"].div.withConfig({
  displayName: "TooltipSortSelect__SortControl",
  componentId: "sc-9aa4ae-0"
})(["display:flex;flex-shrink:0;margin-right:8px;"]);
var SortButton = (0, _styledComponents["default"])(_core.Button).withConfig({
  displayName: "TooltipSortSelect__SortButton",
  componentId: "sc-9aa4ae-1"
})(["padding:0 5px;min-width:120px;justify-content:space-between;"]);
var _default = exports["default"] = TooltipSortSelect;